import { Component, OnInit,Input, Output,EventEmitter } from '@angular/core';
import { CurrencyService } from '../../../../services/currency.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CompararService } from '../../../../services/general/comparar.service';
import { Subscription } from 'rxjs/Subscription';
import {Observable} from 'rxjs/Observable';

declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-modal-comprar',
  templateUrl: './comprar.component.html',
  styleUrls: ['./comprar.component.css']
})
export class ComprarComponent implements OnInit {

@Input('pedido') numeroPedido;  
@Input('titulo') titulo;  
@Input('mensaje') mensaje;  

  constructor(public _currencyService:CurrencyService,private route: ActivatedRoute,private router: Router) { }

  ngOnInit() {  
  
  
  }
  
  cargarHome(){ 
     
     this.router.navigate(['/home']); 
     $('#modalComprar').modal('hide');
  }

}



// WEBPACK FOOTER //
// ./src/app/components/general/modals/comprar/comprar.component.ts